import { useEffect, useRef } from "react";
import { Languages } from "lucide-react";

/**
 * Free Google Translate widget — loads Google's public JS once, mounts a
 * simple inline dropdown. NO API key, NO paid usage.
 *
 * We hide Google's default UI chrome via CSS (in index.css) so it blends
 * with the header, but the underlying <select> is fully functional.
 */
export default function GoogleTranslate({ mobile = false }) {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;

    // Init callback — Google's script calls this by name.
    window.googleTranslateElementInit = () => {
      try {
        // Prevent double init
        if (window.__gtDone) return;
        window.__gtDone = true;
        // eslint-disable-next-line no-new
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "hi",
            includedLanguages: "en,hi,mr,gu,ta,te,bn,pa,ur",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
          },
          "google_translate_element",
        );
      } catch (_) {}
    };

    // Only inject once for the whole app
    if (!document.getElementById("gtranslate-script")) {
      const s = document.createElement("script");
      s.id = "gtranslate-script";
      s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div
      className={
        mobile
          ? "gt-wrap gt-mobile inline-flex items-center gap-1.5"
          : "gt-wrap inline-flex items-center gap-1.5"
      }
      data-testid={mobile ? "gtranslate-mobile" : "gtranslate"}
      title="Translate page"
    >
      <Languages size={12} className="opacity-70" />
      <div id="google_translate_element" />
    </div>
  );
}
